import {
    FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS, UPDATE_MONTHLY_INTAKE, TOGGLE_UPLOAD_FILE_MODEL,
    CANCEL_CHANGE_REQUEST, SUBMIT_CHANGE_REQUEST, SET_CHANGE_REQUEST_DATA, UPDATE_SELECTED_CHECKBOX,
    SUBMIT_SELECTED_INTAKE_BOOK_SUCCESS, SUBMIT_SELECTED_INTAKE_BOOK_FAILED, TOGGLE_MONTHLY_UNBLOCK_REQUEST_MODEL,
    SET_SELECT_UNBLOCK_REQUEST_INTAKEBOOK, MONTHLY_UNBLOCK_REQUEST_NOT_ALLOWED, SUBMIT_MONTHLY_UNBLOCK_REQUEST,SET_SELECTEDINTAKEBOOK_DATA_REQUEST,
    SET_SELECTEDINTAKEBOOK_DATA
} from './actionTypes';

export const monthlyIntakeBookReducer = (state, action) => {
    switch (action.type) {
        case FETCH_INTAKEBOOK_DATE_MONTHLY_DETAILS:
            return {
                ...state,
                monthlyIntakeBookDetails: action.payload.monthlyIntakeBookDetails
            };
        case UPDATE_MONTHLY_INTAKE:
            return {
                ...state,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedRowIndex ?
                    {
                        ...action.payload.selectedIntakeDtl,
                        intakeBookFileName: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed
                            && !action.payload.changeRequestData.isFileUploaded ? null : action.payload.selectedIntakeDtl.intakeBookFileName,
                        intakeBookFilePath: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed
                            && !action.payload.changeRequestData.isFileUploaded ? null : action.payload.selectedIntakeDtl.intakeBookFilePath,
                        userIntakeBookFileName: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed
                            && !action.payload.changeRequestData.isFileUploaded ? null : action.payload.selectedIntakeDtl.userIntakeBookFileName,
                        isFileUploaded: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed
                            ? action.payload.changeRequestData.isFileUploaded : action.payload.selectedIntakeDtl.isFileUploaded,
                        isChangeRequestAllowed: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed,
                        changeRequest: action.payload.changeRequestData ? { ...action.payload.changeRequestData.changeRequest } : null
                    } : data),
                selectedIntakeDtl: {
                    ...action.payload.selectedIntakeDtl
                },
                selectedRowIndex: action.payload.selectedRowIndex
            }
        case TOGGLE_UPLOAD_FILE_MODEL:
            return {
                ...state,
                showUploadFileModel: action.payload.showUploadFileModel,
                acceptFileType: action.payload.acceptFileType,
                modelHeaderTitle: action.payload.modelHeaderTitle
            }
        case CANCEL_CHANGE_REQUEST:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        intakeBookFileName: null,
                        intakeBookFilePath: null,
                        userIntakeBookFileName: null,
                        isFileUploaded: false,
                        changeRequest: {
                            ...data.changeRequest,
                            businessPartnerRemarks: ""
                        },
                        businessPartnerRemarks_ErrorMessage: ""
                    } : data)
            }
        case SET_SELECTEDINTAKEBOOK_DATA_REQUEST:
            return {
                ...state,
                setSelectedRevenue: null,
                submittedRevenue: null,
                selectedContractCodeIndex: null,
                selectedContractCode: null
            }
        case SET_SELECTEDINTAKEBOOK_DATA:
            return {
                ...state,
                submittedRevenue: null,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                selectedContractCode: action.payload.selectedContract,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    { ...action.payload.selectedRevenue } : data)
            }
        case SET_CHANGE_REQUEST_DATA:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        changeRequest: {
                            ...data.changeRequest,
                            businessPartnerRemarks: action.payload.changeRequestData.changeRequest.businessPartnerRemarks
                        },
                        businessPartnerRemarks_ErrorMessage: action.payload.changeRequestData && action.payload.changeRequestData.businessPartnerRemarks_ErrorMessage
                    } : data)
            }
        case SUBMIT_CHANGE_REQUEST:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedRowIndex,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedRowIndex ?
                    {
                        ...data,
                        isChangeRequestAllowed: action.payload.changeRequestData && action.payload.changeRequestData.isChangeRequestAllowed,
                        changeRequest: {
                            ...data.changeRequest,
                            changeRequestNumber: action.payload.changeRequestData.changeRequestNumber,
                            changeRequestStatus: action.payload.changeRequestData.changeRequestStatus
                        }
                    } : data),
                selectedIntakeDtl: {
                    ...action.payload.selectedIntakeDtl
                },
                changeReqNumber: action.payload.changeReqNumber
            }
        case UPDATE_SELECTED_CHECKBOX:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedRowIndex,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedRowIndex ?
                    {
                        ...data,
                        isChecked: action.payload.selectedIntakeDtl.isChecked
                    } : data),
                selectedIntakeDtl: {
                    ...action.payload.selectedIntakeDtl
                }
            }
        case SUBMIT_SELECTED_INTAKE_BOOK_SUCCESS:
            return {
                ...state,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data) => {
                    return { ...setSubmitSelectedSuccessData(data, action.payload.submittedData) }
                }
                ),
            }
        case SUBMIT_SELECTED_INTAKE_BOOK_FAILED:
            return {
                ...state,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data) => {
                    return { ...setSubmitSelectedFailedData(data, action.payload.submittedData) }
                }
                ),
            }
        case TOGGLE_MONTHLY_UNBLOCK_REQUEST_MODEL:
            return {
                ...state,
                showUnblockMonthlyRequestModel: action.payload.showUnblockMonthlyRequestModel
            }
        case SET_SELECT_UNBLOCK_REQUEST_INTAKEBOOK:
            return {
                ...state,
                selectedIntakeDtl: action.payload.selectedRevenue,
                selectedRowIndex: action.payload.selectedContractCodeIndex
            }
        case SUBMIT_MONTHLY_UNBLOCK_REQUEST:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        isUnblockChangeRequestAllowed: action.payload.unblockRequestData && action.payload.unblockRequestData.isChangeRequestAllowed,
                        unblockChangeRequest: {
                            ...data.unblockChangeRequest,
                            changeRequestNumber: action.payload.unblockRequestData.changeRequestNumber,
                            changeRequestStatus: action.payload.unblockRequestData.changeRequestStatus
                        }
                    } : data)
            }
        case MONTHLY_UNBLOCK_REQUEST_NOT_ALLOWED:
            return {
                ...state,
                selectedContractCodeIndex: action.payload.selectedContractCodeIndex,
                monthlyIntakeBookDetails: state.monthlyIntakeBookDetails.map((data, index) => index === action.payload.selectedContractCodeIndex ?
                    {
                        ...data,
                        isUnblockChangeRequestAllowed: false
                    } : data)
            }
        default:
            return state;
    }
}

function setSubmitSelectedSuccessData(contractData, submittedData) {
    const crData = submittedData.filter(d => d.contractId === contractData.contractId);
    if (crData && crData.length === 1) {
        contractData = {
            ...contractData,
            id: crData[0].id,
            isSubmitted: crData[0].id > 0,
            isSelectionAllowed: crData[0].id > 0 ? false : contractData.isSelectionAllowed,
            isChecked: crData[0].id > 0 ? false : contractData.isChecked,
            isFileUploadedError: crData[0].id <= 0,
            createdDate: crData[0].createdDate,
            intakeBookFile: null,
            intakeBookFileName: crData[0].isChangeRequestAllowed && !crData[0].isFileUploaded ? null : contractData.intakeBookFileName,
            intakeBookFilePath: crData[0].isChangeRequestAllowed && !crData[0].isFileUploaded ? null : contractData.intakeBookFilePath,
            userIntakeBookFileName: crData[0].isChangeRequestAllowed && !crData[0].isFileUploaded ? null : contractData.userIntakeBookFileName,
            isFileUploaded: crData[0].isChangeRequestAllowed ? crData[0].isFileUploaded : contractData.isFileUploaded,
            isChangeRequestAllowed: crData[0].isChangeRequestAllowed,
            changeRequest: crData[0].isChangeRequestAllowed ? { ...crData[0].changeRequest } : null
        }
    }
    return contractData;
}

function setSubmitSelectedFailedData(contractData, submittedData) {
    const crData = submittedData.filter(d => d.contractId === contractData.contractId);
    if (crData && crData.length === 1) {
        contractData = {
            ...contractData,
            isFileUploadedError: true
        }
    }
    return contractData;
}